import React from "react";
import cn from "classnames";
import Styles from "./TabViewChooser.module.scss";
import { TabViewChooserItem } from "src/components/atoms/TabViewChooserItem/TabViewChooserItem";

export interface Option {
  label: string;
  "data-testid"?: string;
  value: any;
}
export interface TabViewChooserProps {
  options: string[] | Option[];
  onClick: (viewType: string) => void;
  active: any;
  className?: string;
  variant?: "chooser" | "selector";
}

interface VariantProps {
  dataTestID: string;
  style: string;
}
function getVariantProps(variant: "chooser" | "selector"): VariantProps {
  switch (variant) {
    case "chooser":
      return {
        dataTestID: "stats-view-chooser",
        style: Styles.container,
      };
    case "selector":
      return {
        dataTestID: "stats-selector",
        style: Styles.selectorContainer,
      };
  }
}
export const TabViewChooser = ({ options, onClick, active, className, variant = "chooser" }: TabViewChooserProps) => {
  const variantProps = getVariantProps(variant);

  const items = options
    .map((option) => (typeof option === "string" ? { label: option, value: option } : option))
    .map((option) => (
      <TabViewChooserItem
        data-testid={option["data-testid"]}
        key={option.value}
        label={option.label}
        onClick={() => onClick(option.value)}
        active={active === option.value}
        variant={variant}
      />
    ));

  return (
    <div data-testid={variantProps.dataTestID} className={cn(variantProps.style, className)}>
      {items}
    </div>
  );
};
